import listSagas from '../lists/sagas';

const sagas = [...listSagas];

export default sagas;
